import React, { Component } from 'react';

// import '../style/Header.scss';
import * as globals from '../globals';
import logo from '../img/whitemapperlogo.png';

class App extends Component {
  state = { visible: false };

  render() {
    return (
      <div className="Header">
        <a href={globals.mapperURL} className="clickable">
          <img className="logo" src={logo} alt="DPC Frontier Mapper Logo" />
        </a>
        <div className="right">
          <a href="https://dpcnation.org">What Is DPC?</a>
        </div>
      </div>
    );
  }
}

export default App;
